import Keycloak from "keycloak-js";
import appProps from "./AppConfigContext";
const authInstance = new Keycloak(appProps.keycloak);
export default authInstance;
